import React from "react";
import ReactDOMClient from "react-dom/client";
import App from "./App";
import { ThemeProvider } from "./context.js";

const root = ReactDOMClient.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
